import React from "react";
import { Image, View } from "react-native";
import AccordionItem from "../AccordionItem";

const AccordionItemFull = ({ styles, subSection }) => {
  return (
    <View style={{ paddingBottom: 10, paddingTop: 10 }}>
      <View>{subSection.image && subSection.image(styles)}</View>
    </View>
  );
};

export default AccordionItemFull;
